import React from "react";
import "./feedback-form.styles.scss";
import Button from "../button/button.component";
import InputField2 from "../input-field/input-field2.component";
import TextArea from "../input-field/text-area.component";
import FeedbackImage from "../../assets/images/svg/undraw_feedback_h2ft.svg";

interface IProps {
    error: string;
    onHandleChange: (evt: any, name: string) => void;
    onHandleClick: (evt: any) => void;
}

export default function FeedbackForm({
    error,
    onHandleChange,
    onHandleClick,
}: IProps) {
    return (
        <div className="feedback">
            <div className="title">
                <h2 className="heading">Feedback</h2>
            </div>
            <div className="feedback__detail">
                <div className="feedback__detail__items">
                    <img src={FeedbackImage} alt="FeedbackImage" />
                </div>
                <form className="feedback__detail__items">
                    <div className="feedback__detail__items__item">
                        <InputField2
                            type="text"
                            name="Feedback Name"
                            label="Input your name"
                            onChange={(evt) => onHandleChange(evt, "name")}
                            autoFocus
                        />
                    </div>
                    <div className="feedback__detail__items__item">
                        <TextArea
                            name="Feedback Description"
                            label="Input your feedback description"
                            onChange={(evt) =>
                                onHandleChange(evt, "description")
                            }
                        />
                    </div>
                    {error ? (
                        <div className="feedback__detail__items__error error">
                            {error}
                        </div>
                    ) : (
                        ""
                    )}
                    <Button onClick={onHandleClick}>Send</Button>
                </form>
            </div>
        </div>
    );
}
